module.exports = __webpack_public_path__ + "media/images/logo-klinikum-email-c381f87a1a6476d41c36d9c6ae2e692e.png";